import script from "./InitialRegisterUserInfos.vue?vue&type=script&setup=true&lang=js"
export * from "./InitialRegisterUserInfos.vue?vue&type=script&setup=true&lang=js"

import "./InitialRegisterUserInfos.vue?vue&type=style&index=0&id=31062f64&lang=scss"

const __exports__ = script;

export default __exports__